import { AbacoWebModule, RouterReadyEvent, VueRouter, MenuItem } from "@abaco/web-common/src/app";
import { InspectionVisitSurveysApi } from "./api/InspectionVisitSurveysApi";
import globals from "./globals";
import Vue from "vue";
import myRoutes from "./routes";
import ExampleVuexModule from "./state";
import { HTTPClient } from "@abaco/web-common/src/HTTP";
import { createMenu } from "./menu";
import InspectionVisitApi from "./api/InspectionVisitApi";
import FarmRegistry from "@abaco/farm-registry/src/modules/farm-registry";
import GlobalState from "@abaco/portal-global-state/src/modules/global-state";
import InspectionWorkerApi from "./api/InspectionWorkerApi";
import InspectionNtrmApi from "./api/InspectionNtrmApi";
import InspectionSeedlingLotsApi from "./api/InspectionSeedlingLotsApi";
import InspectionPlotsApi from "./api/InspectionPlotsApi";
import InspectionAccidentsApi from "./api/InspectionAccidentsApi";
import InspectionGarbageBpApi from "./api/InspectionGarbageBpApi";
import "./assets/styles/global.scss";
import InspectionCpaStorageSecurityApi from "./api/InspectionCpaStorageSecurityApi";
import InspectionAlpWashAccommodationApi from "./api/InspectionAlpWashAccommodationApi";
import InspectionFieldActivitiesApi from "./api/InspectionFieldActivitiesApi";
import VisitDacBuDryersApi from "./api/VisitDacBuDryersApi";
import VisitFcvDryersApi from "./api/VisitFcvDryersApi";
import InspectionMonitoringYieldApi from "./api/InspectionMonitoringYieldApi";
import InspectionDamageApi from "./api/InspectionDamageApi";
import VisitFertilizationPlanApi from "./api/VisitFertilizationPlanApi";
import VisitPhCorrectionApi from "./api/VisitPhCorrectionApi";

export const MODULE_ID = "pmi_inspection_module";

export default class InspectionModule implements AbacoWebModule {
  public static MODULE_ID = MODULE_ID;

  public visitSurveysApi!: InspectionVisitSurveysApi;
  private inspectionVisitApi!: InspectionVisitApi;
  private inspectionWorkerApi!: InspectionWorkerApi;
  private inspectionNtrmApi!: InspectionNtrmApi;
  private inspectionSeedlingLotsApi!: InspectionSeedlingLotsApi;
  private inspectionPlotsApi!: InspectionPlotsApi;
  private inspectionMonitoringYieldApi!: InspectionMonitoringYieldApi;
  private inspectionAccidentsApi!: InspectionAccidentsApi;
  private inspectionGarbageBpApi!: InspectionGarbageBpApi;
  private inspectionCpaStorageSecurityApi!: InspectionCpaStorageSecurityApi;
  private inspectionAlpWashAccommodationApi!: InspectionAlpWashAccommodationApi;
  private inspectionFieldActivitiesApi!: InspectionFieldActivitiesApi;
  private visitDacBuDryersApi!: VisitDacBuDryersApi;
  private visitFcvDryersApi!: VisitFcvDryersApi;
  private inspectionDamageApi!: InspectionDamageApi;
  private visitFertilizationPlanApi!: VisitFertilizationPlanApi;
  private visitPhCorrectionApi!: VisitPhCorrectionApi;
  private apiCreated = false;

  private router!: VueRouter;

  readonly id = MODULE_ID;
  readonly routes = myRoutes;
  readonly globalComponents = globals;
  readonly vuexModule = new ExampleVuexModule();

  private evnBus = new Vue();

  get eventBus() {
    return this.evnBus;
  }

  menu: MenuItem[] = [];

  dependsOn = {
    [FarmRegistry.MODULE_ID]: () => new FarmRegistry(),
    [GlobalState.MODULE_ID]: () => new GlobalState(),
  };

  onRouterReady(evt: RouterReadyEvent) {
    this.router = evt.router;
    this.menu = createMenu(this.router);
  }

  async beforeEnterAnyRoutes(http: HTTPClient) {
    if (this.apiCreated) {
      return;
    }
    this.apiCreated = true;

    this.visitSurveysApi = new (await import("./api/InspectionVisitSurveysApi")).InspectionVisitSurveysApi(http);
    const InspectionVisitApi = (await import("./api/InspectionVisitApi")).default;
    this.inspectionVisitApi = new InspectionVisitApi(http);
    const InspectionWorkerApi = (await import("./api/InspectionWorkerApi")).default;
    this.inspectionWorkerApi = new InspectionWorkerApi(http);
    const InspectionNtrmApi = (await import("./api/InspectionNtrmApi")).default;
    this.inspectionNtrmApi = new InspectionNtrmApi(http);
    const InspectionSeedlingLotsApi = (await import("./api/InspectionSeedlingLotsApi")).default;
    this.inspectionSeedlingLotsApi = new InspectionSeedlingLotsApi(http);
    const InspectionPlotsApi = (await import("./api/InspectionPlotsApi")).default;
    this.inspectionPlotsApi = new InspectionPlotsApi(http);
    const InspectionMonitoringYieldApi = (await import("./api/InspectionMonitoringYieldApi")).default;
    this.inspectionMonitoringYieldApi = new InspectionMonitoringYieldApi(http);
    const InspectionAccidentsApi = (await import("./api/InspectionAccidentsApi")).default;
    this.inspectionAccidentsApi = new InspectionAccidentsApi(http);
    const InspectionGarbageBpApi = (await import("./api/InspectionGarbageBpApi")).default;
    this.inspectionGarbageBpApi = new InspectionGarbageBpApi(http);
    const InspectionCpaStorageSecurityApi = (await import("./api/InspectionCpaStorageSecurityApi")).default;
    this.inspectionCpaStorageSecurityApi = new InspectionCpaStorageSecurityApi(http);
    const InspectionAlpWashAccommodationApi = (await import("./api/InspectionAlpWashAccommodationApi")).default;
    this.inspectionAlpWashAccommodationApi = new InspectionAlpWashAccommodationApi(http);
    const InspectionFieldActivitiesApi = (await import("./api/InspectionFieldActivitiesApi")).default;
    this.inspectionFieldActivitiesApi = new InspectionFieldActivitiesApi(http);
    const VisitDacBuDryersApi = (await import("./api/VisitDacBuDryersApi")).default;
    this.visitDacBuDryersApi = new VisitDacBuDryersApi(http);
    const VisitFcvDryersApi = (await import("./api/VisitFcvDryersApi")).default;
    this.visitFcvDryersApi = new VisitFcvDryersApi(http);
    const InspectionDamageApi = (await import("./api/InspectionDamageApi")).default;
    this.inspectionDamageApi = new InspectionDamageApi(http);
    const VisitFertilizationPlanApi = (await import("./api/VisitFertilizationPlanApi")).default;
    this.visitFertilizationPlanApi = new VisitFertilizationPlanApi(http);
    const VisitPhCorrectionApi = (await import("./api/VisitPhCorrectionApi")).default;
    this.visitPhCorrectionApi = new VisitPhCorrectionApi(http);
  }

  public get InspectionVisitApi() {
    return this.inspectionVisitApi;
  }

  public get InspectionWorkerApi() {
    return this.inspectionWorkerApi;
  }

  public get InspectionNtrmApi() {
    return this.inspectionNtrmApi;
  }

  public get InspectionSeedlingLotsApi() {
    return this.inspectionSeedlingLotsApi;
  }

  public get InspectionPlotsApi() {
    return this.inspectionPlotsApi;
  }

  public get InspectionMonitoringYieldApi() {
    return this.inspectionMonitoringYieldApi;
  }

  public get InspectionAccidentsApi() {
    return this.inspectionAccidentsApi;
  }

  public get InspectionGarbageBpApi() {
    return this.inspectionGarbageBpApi;
  }

  public get InspectionCpaStorageSecurityApi() {
    return this.inspectionCpaStorageSecurityApi;
  }

  public get InspectionAlpWashAccommodationApi() {
    return this.inspectionAlpWashAccommodationApi;
  }

  public get InspectionFieldActivitiesApi() {
    return this.inspectionFieldActivitiesApi;
  }

  public get VisitDacBuDryersApi() {
    return this.visitDacBuDryersApi;
  }

  public get VisitFcvDryersApi() {
    return this.visitFcvDryersApi;
  }

  public get InspectionDamageApi() {
    return this.inspectionDamageApi;
  }

  public get VisitFertilizationPlanApi() {
    return this.visitFertilizationPlanApi;
  }

  public get VisitPhCorrectionApi() {
    return this.visitPhCorrectionApi;
  }
}
